import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Dialog from '@material-ui/core/Dialog';
import { MDBContainer, MDBIframe } from "mdbreact";

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import FrDatePicker from '../components/FrDatePicker'
import FrMultipleSelect from '../components/FrMultipleSelect'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, getUserCode } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function RelFpg(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({ sedes: [] })
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [showModal, setShowModal] = useState(false)
  const [loadingReport, setLoadingReport] = useState(false)

  const [comboSed, setComboSed] = useState([{ value: '', display: '' }])
  const [comboRep, setComboRep] = useState([{ value: '', display: '' }])
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])

  const columns = [
    { id: 'descricao', numeric: false, label: 'Nome', align: 'left', minWidth: 200 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setenableAdd(await api.getAcessos('Relatorio Por Fpg', 'Inclusao'))
      setenableEdit(await api.getAcessos('Relatorio Por Fpg', 'Alteracao'))
      setenableDel(await api.getAcessos('Relatorio Por Fpg', 'Exclusao'))

      setComboSed(await api.getComboData('sedes'))
      setComboRep(await api.getComboData('representantes'))
      setComboFpg(await api.getComboData('formas_pagamento'))

      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    queryObject.buscar = true
    queryObject.sedes = JSON.stringify(filter.sedes)
    queryObject.representantes = JSON.stringify(filter.representantes)
    queryObject.fpgs = JSON.stringify(filter.fpgs)
    setFiltered(true)
    console.log(queryObject.sedes)
    if ((queryObject.dataIni) && queryObject.dataFim) {

      window.history.replaceState({ filtered: true }, 'filter', "/salute/relatorio_fpg?" + objectToQueryString(queryObject));
      let dataIni = (filter.dataIni ? 'dataIni=' + filter.dataIni : '')
      let dataFim = (filter.dataFim ? '&dataFim=' + filter.dataFim : '')
      let fpgs = (filter.fpgs ? '&fpgs=' + JSON.stringify(filter.fpgs) : '')
      let representantes = (filter.representantes ? '&representantes=' + JSON.stringify(filter.representantes) : '')
      let sedes = (filter.sedes ? '&sedes=' + JSON.stringify(filter.sedes) : '')

      setLoadingReport(true)
      swal.fire({
        html: <FrLoading text="Carregando relatório..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      setData(api.backendUrl + '/api/relatorio_fpg/pdf?' + dataIni + dataFim + representantes + sedes + fpgs)
      // setData(api.backendUrl + '/api/relatorio_fpgs/pdf?'+(filter.dataIni ? 'dataIni='+filter.dataIni : '')+(filter.dataFim ? '&dataFim='+filter.dataFim : ''))
      // api.get('/relatorio_fpg/pdf', { params: queryObject }).then(r => {
      // console.log(r)
      // setData(r.data)
      // })
    } else {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        title: 'Data não informada!',
        html: '<p>Informe o período da busca.',
        icon: 'warning'
      })
    }
  }

  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/relatorio_fpg');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    console.log(filter, e.target.name, e.target.value)
    // auxValues[e.target.name] = e.target.value;
    // const auxValues = { ...data };
    switch (e.target.name) {
      // case 'sedes': auxValues.sedes.push(e.target.value.value);
      // break;

      default:
        auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };

  function limpaModal() {
    setData(null)
    setShowModal(false)
    setLoadingReport(false)
  }

  function handleReportLoaded() {
    if (loadingReport) {
      swal.close()
      setShowModal(true)
      setLoadingReport(false)
    }
  }
  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Relatório de Vendas por Forma de Pagamento</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <div>
          <Dialog aria-labelledby="simple-dialog-title" open={showModal} fullWidth={true} maxWidth={'lg'} keepMounted>
            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">
                {data && (
                  <MDBContainer className="text-center">
                    <MDBIframe src={data} onLoad={handleReportLoaded} />
                  </MDBContainer>
                )}
                <button onClick={limpaModal}> Sair </button>
              </div>
            </div>
          </Dialog>
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrDatePicker
                value={(filter.dataIni || '').split('T')[0]}
                name="dataIni"
                id="dataIni"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrDatePicker
                value={(filter.dataFim || '').split('T')[0]}
                name="dataFim"
                id="dataFim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrMultipleSelect
                id='sedes'
                value={filter.sedes || []}
                label='Unidade'
                handleChange={handleChange}
                name='sedes'
                data={comboSed}
                style={{ width: 200 }}
              />

              <FrMultipleSelect
                id='representantes'
                value={filter.representantes || []}
                label='Representantes'
                handleChange={handleChange}
                name='representantes'
                data={comboRep}
                style={{ width: 200 }}
              />

              <FrMultipleSelect
                id='fpgs'
                value={filter.fpgs || []}
                label='Formas de Pagamento'
                handleChange={handleChange}
                name='fpgs'
                data={comboFpg}
                style={{ width: 200 }}
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Gerar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>

            </div>
          </form>
        </div>
        <br />
        {/* <div className="tableDiv">
          <FrTable regName="grupo_conta" columns={columns} searched={filtered} codeName="pk_gct" page={'Grupo_conta'} data={data} enableEdit={enableEdit} enableDel={enableDel} />
        </div> */}
        <FooterDelphus />
      </div>
    </div>
  );
}

export default RelFpg;
